import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';

export const GeneralContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xl};
`;

export const TabsContainer = styled.div<{ $forceRow?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  /* El tope de ancho va aquí, en la barra ENTERA. Estuvo en cada mitad
     (max-width 65rem), y en pantalla ancha las dos tocaban el tope y
     quedaban iguales — el peso por nº de pestañas no llegaba a aplicarse
     nunca. */
  width: 100%;
  max-width: 130rem;
  margin: 0 auto;
  /* En tablet la barra se parte en dos filas, que es lo que da sentido a las
     dos mitades: 7 pestañas no caben en una. Con la básica son 4 y sí caben,
     y partirlas dejaba a «Materiales» ocupando una fila entera ella sola. */
  ${({ $forceRow }) =>
    !$forceRow &&
    css`
      @media (max-width: ${({ theme }) =>
          theme.breakPoints.landscapeTablet *
          theme.percentBaseResponsive}rem) {
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing.s};
      }
    `}
`;

/**
 * Mitad de la barra de pestañas.
 *
 * `$tabCount` = cuántas pestañas pinta ESTA mitad. Sin él las dos mitades se
 * reparten el ancho al 50 % pase lo que pase, y una mitad con una sola pestaña
 * se lleva media barra: se vio al retirar Animals de la actuación básica
 * (3 | 1 → «Materiales» ocupaba la mitad). Con el peso, cada pestaña mide
 * igual sea cual sea el reparto.
 *
 * `$wideFirstTab` / `$wideSecondTab` sustituyen a los `:first-child` /
 * `:nth-child(2)` fijos que ensanchaban las etiquetas largas («Operarios y
 * vehículos», «Maquinaria Aux.»): esas posiciones las ocupan otras pestañas
 * cuando alguna se oculta, y el ensanchado caía sobre la que no tocaba.
 */
export const TabsHalf = styled.div<{
  $tabCount?: number;
  $wideFirstTab?: boolean;
  $wideSecondTab?: boolean;
  $forceRow?: boolean;
}>`
  display: flex;
  width: 100%;
  flex: ${({ $tabCount }) => $tabCount ?? 1};
  justify-content: space-between;
  &:first-of-type {
    border: 0.1rem solid ${({ theme }) => theme.colors.greyDark};
    border-right: none;
    border-top-left-radius: ${({ theme }) => theme.borderRadius.lg};
    border-bottom-left-radius: ${({ theme }) => theme.borderRadius.lg};
    ${({ $wideFirstTab }) =>
      $wideFirstTab &&
      css`
        & > a:first-child {
          flex: 1.4;
        }
      `}
  }
  &:last-of-type {
    border: 0.1rem solid ${({ theme }) => theme.colors.greyDark};
    border-left: none;
    border-top-right-radius: ${({ theme }) => theme.borderRadius.lg};
    border-bottom-right-radius: ${({ theme }) => theme.borderRadius.lg};
    ${({ $wideSecondTab }) =>
      $wideSecondTab &&
      css`
        & > a:nth-child(2) {
          flex: 1.4;
        }
      `}
  }
  ${({ $forceRow }) =>
    !$forceRow &&
    css`
      @media (max-width: ${({ theme }) =>
          theme.breakPoints.landscapeTablet *
          theme.percentBaseResponsive}rem) {
        /* Apiladas: cada mitad ocupa su propio ancho, el peso no aplica. */
        flex: initial;
        max-width: 65rem;
        border-radius: ${({ theme }) => theme.borderRadius.lg};
        &:first-of-type {
          border-right: 0.1rem solid ${({ theme }) => theme.colors.greyDark};
        }

        &:last-of-type {
          border-left: 0.1rem solid ${({ theme }) => theme.colors.greyDark};
        }
      }
    `}
`;

export const ButtonTab = styled(NavLink)<{ disabled: boolean }>`
  font-size: ${({ theme }) => theme.fontSize.S};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.greyDark};
  padding: 0.7rem 0;
  flex: 1;
  text-align: center;
  ${(props: { disabled: boolean; theme: any }) =>
    !props.disabled &&
    css`
      color: ${props.theme.colors.black};
      &.active {
        outline: 0.2rem solid ${props.theme.colors.garnet};
        outline-offset: -0.1rem;
        border-radius: ${props.theme.borderRadius.lg};
      }
    `};

  ${(props: { disabled: boolean }) =>
    props.disabled &&
    css`
      cursor: default;
    `};
`;
